import { getCookie } from "./getcookie";

export const BASE_URL = process.env.REACT_APP_API_URL;

console.log(BASE_URL);

export const getToken = () => {
  // Prefer the in-app login token; fall back to the shared mawalog SSO cookie
  // so axiosInstance still authenticates when the session came from the
  // accounts app. getCookie returns a "Bearer <jwt>" string, but the
  // axiosInstance interceptor adds the "Bearer " prefix itself, so strip it.
  const localToken = localStorage.getItem("token");
  if (localToken) return localToken;

  const cookieToken = getCookie("mawalog");
  if (cookieToken) return cookieToken.replace(/^Bearer\s+/i, "");

  return null;
};

export const getAuthHeaders = () => ({
  Authorization: getCookie("mawalog"),
  "Content-Type": "application/json"
});
